<script setup lang="ts">
const benefits = [
  {
    title: 'Kirim Banyak Sekaligus',
    description:
      'Upload daftar paketmu untuk diproses bersamaan, tanpa repot satu per satu.',
    icon: 'material-symbols:package-2-outline',
    iconSize: '33px'
  },
  {
    title: 'Pilihan COD dan Non COD',
    description:
      'Pilihan pembayaran fleksibel untuk penuhi permintaan pelangganmu.',
    icon: 'material-symbols:account-balance-wallet-outline',
    iconSize: '33px'
  },
  {
    title: 'Jenis Layanan Lengkap',
    description:
      'Kirim paket dengan banyak pilihan layanan, ongkir, dan estimasi waktu dari ekspedisi.',
    icon: 'material-symbols:volunteer-activism-outline',
    iconSize: '33px'
  },
  {
    title: 'Jangkauan Pengiriman Luas',
    description: 'Melayani pengiriman ke 500+ kabupaten/kota di Indonesia.',
    icon: 'material-symbols:public',
    iconSize: '33px'
  },
  {
    title: 'Tanpa Minimum Jumlah',
    description:
      'Kirim satu paket ringan tetap aman, untuk kebutuhan bisnis kecil atau personal.',
    icon: 'material-symbols:monitor-weight-outline',
    iconSize: '33px'
  },
  {
    title: 'Diskon Spesial',
    description:
      'Lebih hemat dengan berbagai program diskon ongkir yang menarik.',
    icon: 'material-symbols:confirmation-number-outline',
    iconSize: '33px'
  }
]
</script>

<template>
  <section class="bg-surface-container-low">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <h2
        class="text-2xl leading-7 lg:text-4xl font-bold lg:text-center text-on-secondary-container font-display"
      >
        Keunggulan Kirim Paket Reguler di KiriminAja
      </h2>
      <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <UiCardFeature
          v-for="(benefit, index) in benefits"
          :key="index"
          :icon="benefit.icon"
          :icon-size="benefit.iconSize"
          :title="benefit.title"
          :description="benefit.description"
        />
      </div>

      <CtaBase title="Coba Pengiriman Reguler di KiriminAja Sekarang!" />
    </UiContainer>
  </section>
</template>
